export const ONBOARDING_STEPS = 3;
export const ONBOARDING = 'onboarding';
export const OnboardingStep = {
  CONNECT_DATA: 'connect_data',
  ANALYZE: 'analyze',
  CREATE_SMARTSLIDES: 'create_smartslides',
  INVITE_TEAM: 'invite_team',
  SHARE: 'share',
  DONE: 'done',
};

export const OnboardingEvent = {
  CONNECT_DATA: 'OnboardingEvent:connect_data',
  CREATE_DASHBOARD: 'OnboardingEvent:create_dashboard',
  CREATE_SMARTSLIDES: 'OnboardingEvent:create_smartslides',
  INVITE_TEAM: 'OnboardingEvent:invite_team',
  CREATE_REPORT: 'OnboardingEvent:create_report',
  ADDED_CREDIT_CARD: 'OnboardingEvent:added_credit_card',
  DASHBOARD_GENERATED: 'OnboardingEvent:dashboard_generated',
};

export const BOOK_DEMO_URL =
  'https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ15vowD1g7yNwfcV0R9wN3NRK1VZ7EapMW2Paebv0bMqBBws_eZU2m-10nB9SzXMLnp08JytEji?gv=true';

export const OnboardingPathName = 'onboarding';
